import { type PropsWithChildren, createContext, useContext } from 'react';

import type { SurveyDto, SurveyQuestionDto } from '@/services/api';

type SurveyQuestionContextValue = {
  participationId: string;
  surveyId: string;
  companyId: string;
  remainingQuestions: number;
  totalQuestions: number;
  question: SurveyQuestionDto | undefined;
  questions: Array<SurveyQuestionDto>;
  currentQuestionIndex: number;
  answeredQuestions: number | undefined;
  canProceedSurveyStep: boolean;
  answerBeingSubmitted: boolean;
  setAnswerBeingSubmitted: React.Dispatch<React.SetStateAction<boolean>>;
  survey?: SurveyDto;
  goToNextQuestion: () => void;
  goToPreviousQuestion: () => void;
  goToQuestion: (index: number) => void;
  canGoToNext: boolean;
  canGoToPrevious: boolean;
};

export const SurveyQuestionContext =
  createContext<SurveyQuestionContextValue | null>(null);

export const useSurveyQuestionContext = () => {
  const context = useContext(SurveyQuestionContext);
  if (!context) {
    throw new Error(
      'useSurveyQuestionContext must be used within a SurveyQuestionProvider'
    );
  }
  return context;
};

export const SurveyQuestionProvider: React.FC<
  PropsWithChildren<SurveyQuestionContextValue>
> = ({ children, ...value }) => {
  return (
    <SurveyQuestionContext.Provider
      value={{
        ...value,
      }}
    >
      {children}
    </SurveyQuestionContext.Provider>
  );
};
